import React from 'react';
import ReactDOM from "react-dom";
import HelpComponent from '../HelpComponent';
import GeoTIFF, { fromUrl, fromUrls, fromArrayBuffer, fromBlob } from 'geotiff';

class VisualizedDataGridOption_DataCube extends React.Component{
    constructor(){
        super();
        this.state={
            isSettingOpen:false,
            cover : "null",
            helpMode : "None"
        };
    }
    deleteLayerList(layer){
        const Layer = {
            TITLE:layer.layerName,
            TYPE:layer.layerType
        };
        this.props.deleteLayerList(Layer);
    }
    gotoLayer(){
        var VisualizedDataGridOverlay_DataCube = this.props.layer.layerHandel;
        VisualizedDataGridOverlay_DataCube.goto();
    }
    settingOpen(){
        this.setState({ isSettingOpen: !this.state.isSettingOpen });
    }
    coverChange(event){
        var cover = event.target.value;
        var VisualizedDataGridOverlay_DataCube = this.props.layer.layerHandel;
        if(cover === "null"){
            VisualizedDataGridOverlay_DataCube.setOverlayName();
            window.main.OView.updateScreen();
        }            
        else{
            VisualizedDataGridOverlay_DataCube.setOverlayName(cover);
            window.main.OView.updateScreen();
        }            
        this.setState({cover : cover});
    }
    onHelpClick(mode){
        this.setState({helpMode:mode})
    }
    render(){
        const LayerList_2D = this.props.LayerList_2D;
        const Layer = this.props.layer;
        if (this.state.helpMode === "VisualizedDataGridHelp")    // xj helper 內容待改
        {
            ReactDOM.render(<HelpComponent videoSrc="https://www.youtube.com/embed/1xkg_otY5Vs" onHelpClick={(e)=>this.onHelpClick(e)} />,document.getElementById('Help'));
        }
        if (this.state.helpMode === "None")
        {
            ReactDOM.unmountComponentAtNode(document.getElementById('Help'));      
        }
        return(
            <div className="ts accordion item">
                <div className="ts grid">
                    <div className="ts ten wide column"  style={{alignSelf: 'center'}}>
                        <div className="ts grid">
                            <div className="ts two wide column">
                                <i className="large find icon"></i>
                            </div>
                            <div className="ts fourteen wide column" style={{alignSelf: 'center'}}>
                                <h6 className="layerNameCSS">{Layer.layerName}
                                    <button className="ts circular pulsing mini icon button" style={{fontSize:"10px"}} onClick={(e)=>this.onHelpClick("Acute3DHelp")}>
                                        <i className="help small icon" style={{color:"#919191"}}></i>
                                    </button>
                                </h6>
                            </div>
                        </div>                      
                    </div>
                    <div className="ts two wide column" style={{cursor:"pointer"}} onClick={(e)=>this.deleteLayerList(Layer)} data-tooltip-position="top center" data-tooltip-type="label" data-tooltip="關閉圖層">
                        <i className="large remove circle outline icon"></i>
                    </div>
                    <div className="ts two wide column" style={{cursor:"pointer"}} onClick={(e)=>this.gotoLayer()} data-tooltip-position="top center" data-tooltip-type="label" data-tooltip="前往圖層位置">
                        <i className="large marker icon"></i>
                    </div>
                    <div className="ts two wide column" style={{cursor:"pointer"}} onClick={(e)=>this.settingOpen()} data-tooltip-position="top center" data-tooltip-type="label" data-tooltip="圖層設定">
                        <i className="large setting icon"></i>
                    </div>
                </div>
                {
                    this.state.isSettingOpen?
                    <div className="ts very narrow container segment" >                        
                        <div className="ts grid">
                            <div className="ts ten wide column" style={{alignSelf: 'center'}}>
                                <h6 className="layerNameCSS">影像披覆：</h6>
                            </div>
                            <div className="ts six wide column">
                                <select className="ts borderless basic dropdown" onChange={(e)=>this.coverChange(e)} value={this.state.cover} style={{width:"100%"}}>
                                    <option value="null">無</option>
                                    {
                                        LayerList_2D.map(
                                            (layer)=>
                                                <option value={layer.layerName}>{layer.layerName}</option> 
                                        )
                                    }
                                </select>
                            </div>
                        </div>
                    </div> : null
                }
                
            </div>
        );
    }
}
class VisualizedDataGridOverlay_DataCube extends React.Component{
    constructor()
    {
        super();
        this.state = {
            isChecked:false,
            VisualizedDataGridOverlay_DataCube:{}
        };   
        this.VisualizedDataGridOverlay_DataCubeChecked = this.VisualizedDataGridOverlay_DataCubeChecked.bind(this);

        this.vaColorMapKey = [
            0.0,
            0.5,
            1.0,
            2.0,
            3.0,
            4.0,
            5.0
        ];

        this.vaColorMapValue = [
            "#00000000",
            "#0000ff88",
            "#00ff0088",
            "#ffd80088",
            "#ff6a0088",
            "#ff000088",
            "#ff006e88"
        ];

        // Variables
        this.vOverlay = null;
        this.vLayerSrc = null;

        this.vaDate = [];
        let date = new Date();  // Set initial date
        this.vaDate.push(date);

        this.vWidgetTimeline = null;
        this.vWidgetTimelinePlayer = null;
    }
    componentDidUpdate()
    {
        if (this.props.deleteList.layerName === this.props.layer.TITLE)
        {
            let isChecked = this.state.isChecked;
            if (isChecked)
            {
                // Hide Layer & Timeline
                this.vOverlay.show = false; // 無效
                this.vOverlay.opacity = 0;
                this.vWidgetTimeline.hide();
                this.vWidgetTimelinePlayer.hide();

                // Update UI
                window.alertify.error("已關閉圖層："+this.props.layer.TITLE);
                isChecked = !isChecked;
                this.setState({isChecked:isChecked,VisualizedDataGridOverlay_DataCube:{}});
            }            
        }
    }
    GetNameFromURL(url)
    {
        let vaTemp = url.split("\"");

        if (vaTemp.length > 1)
        {
            return vaTemp[1];
        }
        else
        {
            console.log("error: name from url error.");
            return "";
        }
    }
    GetGeoTiffBuffer(url)
    {
        return new Promise(function (resolve, reject)
        {
            let xhr = new XMLHttpRequest();
            xhr.open("POST", url, true);
            xhr.responseType = "arraybuffer";   // or "text" (測試 GetCapbility 用)
            xhr.setRequestHeader('Authorization', 'Basic cmFzYWRtaW46cmFzYWRtaW4=');
            xhr.onload = function (oEvent) {
                if (this.status >= 200 && this.status < 300) {
                    resolve(xhr.response); // GetCoverage Test (geotiff.fromArrayBuffer)
                }
                else {
                    reject({
                        status: this.status,
                        statusText: xhr.statusText
                    });
                }
            };
            xhr.onerror = function () {
                reject({
                    status: this.status,
                    statusText: xhr.statusText
                });
            };
            xhr.send();
        });
    }
    async GetFloodData(vaFloodDataList, vaFloodData, id)
    {
        try {
            if (vaFloodData[id].data === null) 
            {
                let arrayBuffer = await this.GetGeoTiffBuffer(vaFloodData[id].url);
                vaFloodData[id].arrayBuffer = arrayBuffer;
                let tiff = await fromArrayBuffer(arrayBuffer);
                let image = await tiff.getImage();  // by default, the first image is read.
                let data = await image.readRasters();
                vaFloodData[id].data = data[0];
                vaFloodData[id].image = image;
                vaFloodData[id].name = this.GetNameFromURL(vaFloodData[id].url);
                vaFloodData[id].datetime = this.vaDate[0].getTime() + 360000 * id;
            }

            return vaFloodData[id];
        }
        catch (errMsg) {
            console.log("Error in GetFloodData: [" + errMsg + "]");
        }
    }
    async SetTerrainOverlayAll(vaFloodDataList, vaFloodData)
    {
        let vaData = [];

        // Get all FloodData
        for (let i = 0; i < vaFloodData.length; i++)
        {
            let vFloodData = await this.GetFloodData(vaFloodDataList, vaFloodData, i);
            vaData.push(vFloodData.data);

            if (i != 0)  // vaDate[0] 已經預先產生
                this.vaDate.push(vFloodData.datetime);
        }

        // Get Basic info
        let vFloodData = vaFloodData[0];
        let width = vFloodData.image.getWidth();
        let height = vFloodData.image.getHeight();
        let bbox = vFloodData.image.getBoundingBox(); // [w,s,e,n]

        // Set TerrainVisualizedDataGridOverlay_DataCube
        this.vLayerSrc = {
            layername: "Flood",
            source: vaData,
            boundary: new window.GeoBoundary(bbox[0], bbox[1], bbox[2], bbox[3]),   // [w,s,e,n], ex. 118.0, 21.0, 123.0, 25.0
            width: width,
            height: height,
            heightScale: 5000, // xj 有作用，但該設多少? magic number!!
            date: this.vaDate,
            useStepLayeredColorMap: false,
//            layeredColorMapKey: this.vaColorMapKey,
//            layeredColorMapValue: this.vaColorMapValue,
            playSpeed: 0.0005,    // default: 0.16
            repeat: true        // default: true
        };

        this.vOverlay = window.main.OView.addTerrainVisualizedDataGridOverlay(this.vLayerSrc);
    }
    async VisualizedDataGridOverlay_DataCubeChecked(layer)
    {
        let isChecked = this.state.isChecked;
        const layerThis = this;             
        if (!isChecked)
        {
            if (this.vOverlay === null)  // 第一次 Load 淹水資料
            {
                let vaFloodDataList = layer.FloodDataList;

                function CFloodData(url)
                {
                    this.name = "";
                    this.url = url;
                    this.arraybuffer = null;
                    this.data = null;
                    this.image = null;
                    this.datetime = null;
                }

                var vaFloodData = [];  // 改成 FloodData(data, image) 和 Overlay (Overlay, LayerSrc) 全部放在一起管理
                for (let i = 0; i < vaFloodDataList.length; i++) {
                    let floodData = new CFloodData(vaFloodDataList[i]);
                    vaFloodData.push(floodData);
                }

                await this.SetTerrainOverlayAll(vaFloodDataList, vaFloodData);

                // Set Time UI
                this.vWidgetTimeline = new window.ov.Widget.Timeline({ view: window.main.OView, startTime: this.vaDate[0].getTime(), stopTime: this.vaDate[0].getTime() + 360000 * (this.vaDate.length - 1), isRepeat: true });
                this.vWidgetTimelinePlayer = new window.ov.Widget.TimelinePlayer({ view: window.main.OView, timeline: this.vWidgetTimeline, playSpeed: 1000.0, play: true });
                this.vWidgetTimeline.addLink(this.vOverlay);
            }
            else
            {
                this.vOverlay.show = true;
                this.vOverlay.opacity = 1;
                this.vWidgetTimeline = new window.ov.Widget.Timeline({ view: window.main.OView, startTime: this.vaDate[0].getTime(), stopTime: this.vaDate[0].getTime() + 360000 * (this.vaDate.length - 1), isRepeat: true });
                this.vWidgetTimelinePlayer = new window.ov.Widget.TimelinePlayer({ view: window.main.OView, timeline: this.vWidgetTimeline, playSpeed: 1000.0, play: true });
                this.vWidgetTimeline.addLink(this.vOverlay);
            }

            // Goto 
            if (layer.LOCATION != null)
            {
                var Pos = new window.Geo3DPoint(layer.LOCATION.POS.x, layer.LOCATION.POS.y, layer.LOCATION.POS.z);
                var V = new window.Geo3DPoint(layer.LOCATION.V.x, layer.LOCATION.V.y, layer.LOCATION.V.z);
                var Up = new window.Geo3DPoint(layer.LOCATION.UP.x, layer.LOCATION.UP.y, layer.LOCATION.UP.z);
                var Camera = new window.ov.Camera(Pos, V, Up);
                window.main.OView.gotoCamera(Camera, true);
            }

            // Update UI
            window.alertify.success("已開啟圖層：" + layer.TITLE);
            layerThis.props.setOpenLayer(layer, VisualizedDataGridOverlay_DataCube);
            isChecked = !isChecked;
            layerThis.setState({ isChecked: isChecked, VisualizedDataGridOverlay_DataCube: VisualizedDataGridOverlay_DataCube });
        }
        else
        {
            // Hide Layer & Timeline
            this.vOverlay.show = false; // 無效
            this.vOverlay.opacity = 0;  // 要再找確實移除的方法，並考慮是否要清除 load 的資料。
            this.vWidgetTimeline.remove();
            this.vWidgetTimelinePlayer.remove();

            // Update UI
            layerThis.props.deleteLayer(layer);
            window.alertify.error("已關閉圖層："+layer.TITLE);
            isChecked = !isChecked;    
            layerThis.setState({ isChecked: isChecked, VisualizedDataGridOverlay_DataCube: {} });
        }                      
    }    
    render(){
        const layer = this.props.layer;
        return(
            <div className="ts checkbox">
                <input type="checkbox" name="VisualizedDataGridOverlay_DataCube" id={layer.TITLE} checked={this.state.isChecked} onChange={(e)=>this.VisualizedDataGridOverlay_DataCubeChecked(layer)}></input>
                <label htmlFor={layer.TITLE}>{layer.TITLE}</label>
            </div>
        );
    }
}

export  {VisualizedDataGridOverlay_DataCube,VisualizedDataGridOption_DataCube};